<script setup lang="ts">
import MyAccountData from '@/views/MyAccountView/MyAccountData.vue'
import { EProviders, type MyAccountProviderType } from '@rfc/rfc-components-library/types'
import { computed, provide } from 'vue'

const myAccountProvider = computed<MyAccountProviderType>(() => ({
    dataComponent: MyAccountData
}))

provide<MyAccountProviderType>(EProviders.MY_ACCOUNT, myAccountProvider.value)
</script>

<template>
    <slot />
</template>
